// --- Initialize ---
export const SHIPMENT_INITIALIZE_REQUEST = 'SHIPMENT_INITIALIZE_REQUEST'
export const SHIPMENT_INITIALIZE_SUCCESS = 'SHIPMENT_INITIALIZE_SUCCESS'
export const SHIPMENT_INITIALIZE_FAIL = 'SHIPMENT_INITIALIZE_FAIL'

// --- Fetch Multiple Shipments / Grid / Summary ---
export const SHIPMENT_LIST_REQUEST = 'SHIPMENT_LIST_REQUEST'
export const SHIPMENT_LIST_SUCCESS = 'SHIPMENT_LIST_SUCCESS'
export const SHIPMENT_LIST_FAIL = 'SHIPMENT_LIST_FAIL'

export const SHIPMENT_GRID_REQUEST = 'SHIPMENT_GRID_REQUEST'
export const SHIPMENT_GRID_SUCCESS = 'SHIPMENT_GRID_SUCCESS'
export const SHIPMENT_GRID_FAIL = 'SHIPMENT_GRID_FAIL'

export const SHIPMENT_SUMMARY_REQUEST = 'SHIPMENT_SUMMARY_REQUEST'
export const SHIPMENT_SUMMARY_SUCCESS = 'SHIPMENT_SUMMARY_SUCCESS'
export const SHIPMENT_SUMMARY_FAIL = 'SHIPMENT_SUMMARY_FAIL'

export const SHIPMENT_COUNT_REQUEST = 'SHIPMENT_COUNT_REQUEST'
export const SHIPMENT_COUNT_SUCCESS = 'SHIPMENT_COUNT_SUCCESS'
export const SHIPMENT_COUNT_FAIL = 'SHIPMENT_COUNT_FAIL'

// --- Single Shipment Operations ---
export const SHIPMENT_DETAILS_REQUEST = 'SHIPMENT_DETAILS_REQUEST'
export const SHIPMENT_DETAILS_SUCCESS = 'SHIPMENT_DETAILS_SUCCESS'
export const SHIPMENT_DETAILS_FAIL = 'SHIPMENT_DETAILS_FAIL'

export const SHIPMENT_CREATE_REQUEST = 'SHIPMENT_CREATE_REQUEST'
export const SHIPMENT_CREATE_SUCCESS = 'SHIPMENT_CREATE_SUCCESS'
export const SHIPMENT_CREATE_FAIL = 'SHIPMENT_CREATE_FAIL'
export const SHIPMENT_CREATE_RESET = 'SHIPMENT_CREATE_RESET'

export const SHIPMENT_UPDATE_REQUEST = 'SHIPMENT_UPDATE_REQUEST'
export const SHIPMENT_UPDATE_SUCCESS = 'SHIPMENT_UPDATE_SUCCESS'
export const SHIPMENT_UPDATE_FAIL = 'SHIPMENT_UPDATE_FAIL'
export const SHIPMENT_UPDATE_RESET = 'SHIPMENT_UPDATE_RESET'

export const SHIPMENT_DELETE_REQUEST = 'SHIPMENT_DELETE_REQUEST'
export const SHIPMENT_DELETE_SUCCESS = 'SHIPMENT_DELETE_SUCCESS'
export const SHIPMENT_DELETE_FAIL = 'SHIPMENT_DELETE_FAIL'

// --- Allocation ---
export const SHIPMENT_ALLOCATE_REQUEST = 'SHIPMENT_ALLOCATE_REQUEST'
export const SHIPMENT_ALLOCATE_SUCCESS = 'SHIPMENT_ALLOCATE_SUCCESS'
export const SHIPMENT_ALLOCATE_FAIL = 'SHIPMENT_ALLOCATE_FAIL'

// --- Warehouse and Ship Via Options ---
export const GET_WAREHOUSE_OPTIONS_REQUEST = 'GET_WAREHOUSE_OPTIONS_REQUEST'
export const GET_WAREHOUSE_OPTIONS_SUCCESS = 'GET_WAREHOUSE_OPTIONS_SUCCESS'
export const GET_WAREHOUSE_OPTIONS_FAIL = 'GET_WAREHOUSE_OPTIONS_FAIL'

export const GET_SHIPVIA_OPTIONS_REQUEST = 'GET_SHIPVIA_OPTIONS_REQUEST'
export const GET_SHIPVIA_OPTIONS_SUCCESS = 'GET_SHIPVIA_OPTIONS_SUCCESS'
export const GET_SHIPVIA_OPTIONS_FAIL = 'GET_SHIPVIA_OPTIONS_FAIL'
